<template>
<div class="user-detail">
    <div class="container-fluid" v-if="userReady">
        <div class="row">
            <amf-input label="User Name" v-model="data.userName" :validator="$v.data.userName" :disabled="!canEditDemographics"/>
            <amf-input label="Email" v-model="data.email" :validator="$v.data.email" :disabled="!canEditDemographics"/>
            <amf-input label="First Name" v-model="data.firstName" :validator="$v.data.firstName" :disabled="!canEditDemographics" />
            <amf-input label="Last Name" v-model="data.lastName" :validator="$v.data.lastName" :disabled="!canEditDemographics" />
            <amf-input label="Title" v-model="data.title" :disabled="!canEditDemographics" />
            <amf-input label="Extension" v-model="data.extension" :disabled="!canEditDemographics" />
            <amf-checkbox label="Participant Amazon Connect Agent" v-model="data.frontLinePX" v-if="showFrontLineCheckbox"/>
        </div>
        <div class="row" v-if="action == 'Add' && can.createUser">
            <amf-input label="Password" v-model="data.password" :validator="$v.data.password" />
            <amf-input label="Confirm Password" v-model="data.confirmPassword" :validator="$v.data.confirmPassword" />
        </div>
        <div class="row">
            <amf-multiple-select label='Roles' caption="--Select Roles--" v-model="data.roles" :options="roleLabels"
                    :validator="$v.data.roles" :columns="2" :disabled="!canEditUserRoles"/>
        </div>


    </div>
</div>
</template>

<script>
import { userRoles } from './user-labels.js';
import Multiselect from "vue-multiselect";
import { modalService } from '../framework/utils/modal-service';
import AmfCheckbox from "../framework/primitives/AmfCheckbox";

export default {
    components: {AmfCheckbox, Multiselect },
    data() {
        return {
            data: {
                ...amfx.clone("user", "state.*"),
                password: null,
                confirmPassword: null,
            },
            userRoles: userRoles,
            amfOptions: { layout: "two-column" },
        }
    },
    methods: {
        async save() {
            let user = {}
            Object.assign(user, this.data);
            user.roles = this.data.roles ? this.data.roles.map(x => x.id) : [];
            let saveType = user.userId ? 'update' : 'create';
            await this.$store.dispatch('user/' + saveType, { user });
        },
        async setActivation(isApproved) {
            await this.$store.dispatch('user/activation', { userId: this.data.userId, isApproved: isApproved });
        },
        async deactivate() { this.setActivation(false) },
        async activate() { this.setActivation(true) },
        async emailLink() {
            if (await modalService.confirm("Are you sure you want to reset the user's password? This will email the user a link to reset their password."))
            {
                let result = await romeApi.get("/authentication/password/reset?username=" + encodeURIComponent(this.data.userName));
                if(result && result.success) {
                    toastService.success('An email with instructions has been sent to the user.');
                }
                else if(result && result.success == false) {
                    let message = "Unable to send password reset";
                    if(result.data == "RESET_LIMIT") {
                        message = "User's password cannot be changed again today";
                    }
                    toastService.error(message);
                }
            }
        },
        async generateLoginCode() {
            let result = await romeApi.get(`/authentication/password/reset/login-code?userId=${this.data.userId}`);
            await modalService.info(`Please provide the user the following temporary password. Upon logging in, they must change the password before they can proceed to their dashboard<br/><br/><strong>${result.loginCode}</strong>`);
        },
        async resetPassword(user) {
            var options = [ { id: 'email', name: 'Email a reset password link'}, { id: 'code', name: 'Generate a login code' } ];
            var result = await modalService.select('Select Reset Option', 'email', options, 'Password Reset');

            if(result == 'email') {
                await this.emailLink();
            }
            else if(result == 'code') {
                await this.generateLoginCode();
            }
        },
        excludedUser(id) {
            //console.log("UserDetail excludedUser id: ", id)
            return id == "broker" || id == "producersupport" || id == "employer";
        }
    },
    computed: {
        ...amfx.map("user", ["userReady"]),
        ...amfx.map("session", ["roles", "userId", "isInternalUser"]),
        showFrontLineCheckbox() {
          return this.data && this.data.roles && this.data.roles.map(x => x.id).includes('msr');
        },
        action() {
            return this.data.userId ? 'Edit' : 'Add';
        },
        title() {
            return this.action + " User Details";
        },
        buttonsCustom() {
            var buttons = [];
            if (this.action != 'Add' && this.canEditDemographics) buttons.push(this.data.isApproved ? '!Deactivate' : '!Activate');
            if (this.action != 'Add' && this.canResetPassword && this.data.isApproved) buttons.push("!Reset Password");

            return buttons.join("/");
        },
        roleLabels() {
            if (this.action == 'Add') {
                if (this.roles.includes('admin') || this.roles.includes('teammanager')) {
                    return userRoles.filter(x => !this.excludedUser(x.id));
                } else return userRoles.filter(x => !this.excludedUser(x.id) && x.external == true);
            }
            if (this.data.isExternalUser) return userRoles.filter(x => x.external == true);
            return userRoles;
        },
        canEditDemographics() {
            if (this.action == "Add" || this.userId === this.data.userId || this.data.isExternalUser || this.roles.includes('admin')) return true;
            let selectedUserRoles = this.data.roles.map(r => r.id);
            if (this.roles.includes('teammanager')) {
                if (selectedUserRoles.includes('admin') || selectedUserRoles.includes('teammanager')) return false;
                else return true;
            }
            return false;
        },
        canResetPassword() {
            var selectedUserRoles = this.data.roles.map(r => r.id);
            if (this.userId === this.data.userId || this.roles.includes('admin') || this.data.isExternalUser) return true;
            if (this.roles.includes('teammanager')) return selectedUserRoles.includes('admin') ? false : true
            if (this.roles.some(r => selectedUserRoles.includes(r))) return true;
            return false;
        },
        canEditUserRoles() {
            if (this.data.isExternalUser || this.roles.includes('admin') || this.action == 'Add') return true;
            return false;
        }
    },
    validations() {
        return {
            data: {
                userName: v.build(v.required()),
                email: v.build(v.required(), v.email()),
                firstName: v.build(v.required()),
                lastName: v.build(v.required()),
                roles: v.build(v.required()),
                //roles: v.build(v.required(), v.custom(x => !x || x.length < 1, "At least one role must be selected.")),
                password: v.build(v.requiredIf(x => this.action == 'Add')),
                confirmPassword: v.build(v.requiredIf(x => this.action == 'Add'),
                    v.custom(x => x ? this.data.password == this.data.confirmPassword : true, "Passwords do not match.")),
            }
        };
    },
}
</script>



// WEBPACK FOOTER //
// src/user/UserDetail.vue